import React from "react";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import TooltipWrapper from "../../../../../../enhancers/TooltipWrapper";
import RenderWhen from "../../../../../../components/RenderWhen";

type YaraMatchesMoreRulesTooltipProps = {
  rules: string[];
};

const YaraMatchesMoreRulesTooltip = ({
  rules
}: YaraMatchesMoreRulesTooltipProps) => (
  <RenderWhen condition={rules.length > 0}>
    <TooltipWrapper
      condition={rules.length}
      wrapper={(children: JSX.Element) => (
        <OverlayTrigger
          overlay={<Tooltip>{rules.join(", ")}</Tooltip>}
          placement="bottom"
        >
          <span className={"k-pdf-yara-matches-tooltip"}>{children}</span>
        </OverlayTrigger>
      )}
    >
      (+{rules.length} More)
    </TooltipWrapper>
  </RenderWhen>
);

export default YaraMatchesMoreRulesTooltip;
